// Инлайновые SVG-иконки типов блока. Переиспользуются таймлайном (см. CONTRACT.md).
import type { SegmentKind } from '../../types';

export interface KindIconProps {
  kind: SegmentKind;
  size?: number;
  className?: string;
}

/** 14px по умолчанию, единый визуальный стиль (stroke 2.0, viewBox 24x24,
    скругления под капсулы Liquid Glass — как у иконок знака в Logo.tsx). */
export function KindIcon({ kind, size = 14, className }: KindIconProps) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
    focusable: false,
  };

  switch (kind) {
    case 'flight':
      return (
        <svg {...common}>
          <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
        </svg>
      );
    case 'transfer':
      return (
        <svg {...common}>
          <path d="M3.4 15.4v-2.9c0-.4.1-.8.3-1.2l2.2-3.8c.4-.7 1.1-1.1 1.9-1.1h8.4c.8 0 1.5.4 1.9 1.1l2.2 3.8c.2.4.3.8.3 1.2v2.9" />
          <path d="M4.2 11.6h15.6" />
          <path d="M2.4 15.4h19.2" />
          <circle cx="7.4" cy="17.4" r="1.9" />
          <circle cx="16.6" cy="17.4" r="1.9" />
        </svg>
      );
    case 'lodging':
      return (
        <svg {...common}>
          <rect x="3" y="11" width="18" height="6" rx="2" />
          <path d="M3 17v3M21 17v3" />
          <rect x="5" y="8" width="5" height="3" rx="1.5" />
        </svg>
      );
    case 'taxi':
      return (
        <svg {...common}>
          <path d="M4 16l1.2-4.8A2 2 0 0 1 7.1 9.8h9.8a2 2 0 0 1 1.9 1.4L20 16" />
          <rect x="2.5" y="16" width="19" height="3.5" rx="1.75" />
          <circle cx="7" cy="19.5" r="1.4" fill="currentColor" stroke="none" />
          <circle cx="17" cy="19.5" r="1.4" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'food':
      return (
        <svg {...common}>
          <path d="M6 2v7a2 2 0 1 0 4 0V2" />
          <path d="M8 9v13" />
          <path d="M16 2c-1.5 1-2.5 3-2.5 5.5S14.5 12 16 13v9" />
        </svg>
      );
    case 'baggage':
      return (
        <svg {...common}>
          <rect x="3" y="7" width="18" height="13" rx="4" />
          <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <path d="M3 12h18" />
        </svg>
      );
    case 'misc':
    default:
      return (
        <svg {...common}>
          <circle cx="6" cy="12" r="1.6" fill="currentColor" stroke="none" />
          <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
          <circle cx="18" cy="12" r="1.6" fill="currentColor" stroke="none" />
        </svg>
      );
  }
}
